export class ApiError extends Error {
  statusCode: number;
  endpoint: string;
  args?: Record<string, unknown>;
  response?: Response;

  constructor(
    message: string,
    statusCode: number,
    endpoint: string,
    args?: Record<string, unknown>,
    response?: Response,
  ) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.endpoint = endpoint;
    this.args = args;
    this.response = response;
  }
}

export class Api4xxError extends ApiError {
  constructor(statusCode: number, endpoint: string, args?: Record<string, unknown>, response?: Response) {
    super(`Client error ${statusCode} occurred while fetching ${endpoint}`, statusCode, endpoint, args, response);
    this.name = 'Api4xxError';
  }
}

export class Api404Error extends Api4xxError {
  constructor(endpoint: string, args?: Record<string, unknown>, response?: Response) {
    super(404, endpoint, args, response);
    this.name = 'Api404Error';
  }
}

export class Api400Error extends Api4xxError {
  constructor(endpoint: string, args?: Record<string, unknown>, response?: Response) {
    super(400, endpoint, args, response);
    this.name = 'Api400Error';
  }
}
